




"use strict";

import scrollIntoView from './scroll-into-view';


export default function setupOnderhoudForm () {
    const onderhoudFormHolder = document.querySelector('.onderhoud-form-holder');

    if ( !onderhoudFormHolder ) return;

    const onderhoudForm = onderhoudFormHolder.querySelector('.onderhoud-form');
    const overzicht = onderhoudFormHolder.querySelector('.overzicht');
    const steps = onderhoudFormHolder.querySelectorAll('.form-steps .step');

    let currentPageIndex = 0;

    if ( onderhoudForm ) {
        const pages = onderhoudForm.querySelectorAll('.form-page');
        const pageButtons = onderhoudForm.querySelectorAll('.page-button');


        function setupPageHeight () {
            const currentPageHeight = pages[currentPageIndex].getBoundingClientRect().height;
            onderhoudForm.style.height = currentPageHeight + 'px';
        }

        function setupContractFields () {
            const contractOptions = onderhoudForm.querySelectorAll('select [data-contract');
            const contract = onderhoudForm.querySelector('.onderhoud-selector input:checked');
            const hiddenField = onderhoudFormHolder.querySelectorAll('.hidden-eenmalig');

            if ( contract && contract.value ) {
                contractOptions.forEach(option => {
                    const allowedContracts = option.dataset.contract.split(',');

                    if ( allowedContracts.indexOf(contract.value) !== -1 ) {
                        option.disabled = false;
                    } else {
                        option.disabled = true;
                    }

                    if ( contract.value === 'eenmalig' ) {
                        hiddenField.forEach(elem => elem.classList.add('hidden'));
                    } else {
                        hiddenField.forEach(elem => elem.classList.remove('hidden'));
                    }
                });
            }
        }

        function updatePage () {
            onderhoudForm
                .querySelector('.form-page[aria-current]')
                .removeAttribute('aria-current');

            pages[currentPageIndex]
                .setAttribute('aria-current', 'step');

            overzicht.setAttribute('aria-hidden', currentPageIndex === 0);

            steps.forEach(step => step.removeAttribute('aria-current'));
            steps[currentPageIndex].setAttribute('aria-current', 'step');

            setupPageHeight();
        }

        function gotoPrevPage () {
            if ( ! pages[currentPageIndex-1]) return;

            currentPageIndex--;
            updatePage();

            scrollIntoView(onderhoudFormHolder);
        }

        function gotoNextPage () {
            if ( ! pages[currentPageIndex+1]) return;

            currentPageIndex++;
            updatePage();

            scrollIntoView(onderhoudFormHolder);
        }

        function gotoPage (pageIndex) {
            if ( ! pages[pageIndex]) return;

            currentPageIndex = pageIndex;
            updatePage();

            scrollIntoView(onderhoudFormHolder);
        }

        function setupHandles () {
            const inputs = onderhoudForm.querySelectorAll('[data-handle]');

            inputs.forEach(input => {
                const handle = input.dataset.handle;
                const sideField = overzicht.querySelector(`.${handle} .value`);

                input.addEventListener('change', () => {
                    sideField.innerHTML = input.value;
                });
            });
        }

        function setupConditionals () {
            const inputs = onderhoudForm.querySelectorAll('[data-conditional], [data-conditional-no-error]');

            inputs.forEach(input => {
                const fieldControl = input.closest('.field-control');
                if ( !input.classList.contains('overlay-info-button') ) {
                  fieldControl.classList.add('hidden');
                  input.setAttribute('disabled', 'disabled');
                }

                /*
                if ( input.dataset.conditionalNoError ) {
                  const [name, valueStr] = input.dataset.conditionalNoError.split('=');
                  const value = valueStr.split(',');
                  const fields = onderhoudForm.querySelectorAll(`[name="${name}"]`);
                  console.log(fields);
                }
                */

                if ( input.dataset.conditional ) {
                  const [name, valueStr] = input.dataset.conditional.split('=');
                  const value = valueStr.split(',');
                  const fields = onderhoudForm.querySelectorAll(`[name="${name}"]`);

                  fields.forEach(field => field.addEventListener('change', () => {

                    validateField(field)
                      .then(response => {
                        if (value.indexOf(field.value) !== -1) {
                          if (!input.classList.contains('overlay-info-button')) {
                            fieldControl.classList.remove('hidden');
                          }
                          input.removeAttribute('disabled');
                        } else {
                          if (!input.classList.contains('overlay-info-button')) {
                            fieldControl.classList.add('hidden');
                          }
                          input.setAttribute('disabled', 'disabled');
                        }

                        setupPageHeight();
                      });
                  }));
                }
            });
        }

        function calculateTotalPrice (priceInputs) {
            let totalPrice = 0;

            const contract = onderhoudForm.querySelector('.onderhoud-selector input:checked');
            [...priceInputs]
                .filter(input => input.checked)
                .forEach(input => {
                    let priceValue = input.dataset.price;

                    if ( contract && contract.value === 'eenmalig' ) {
                        priceValue = input.dataset.priceOnce || input.dataset.price;
                    }

                    totalPrice += parseFloat(priceValue);
                });


            const price = new Intl.NumberFormat(
                'nl-NL',
                { style: 'currency', currency: 'EUR' }
            ).format(totalPrice);

            overzicht
                .querySelector('.price-overview .total-price')
                .innerHTML = price;
        }

        function setupPrices () {
            const inputs = onderhoudForm.querySelectorAll('[data-price]');
            let calcTotalInputs = [];

            inputs.forEach(input => {

                let priceValue = input.dataset.price;

                const name = input.dataset.name;
                let price = new Intl.NumberFormat(
                    'nl-NL',
                    { style: 'currency', currency: 'EUR' }
                ).format(priceValue);
                const priceLabel = overzicht.querySelector(`.price-overview .${input.name}`)
                const priceField = overzicht.querySelector(`.${input.name}-price`);

                if ( !priceField.closest('.extra-prices') ) {
                    calcTotalInputs.push(input);
                }

                input.addEventListener('change', () => {

                  validateField(input)
                    .then(() => {
                      const contract = onderhoudForm.querySelector('.onderhoud-selector input:checked');
                      if ( contract && contract.value === 'eenmalig' ) {
                          priceValue = input.dataset.priceOnce || input.dataset.price;
                          price = new Intl.NumberFormat(
                              'nl-NL',
                              { style: 'currency', currency: 'EUR' }
                          ).format(priceValue);
                      } else {
                          priceValue = input.dataset.price;
                          price = new Intl.NumberFormat(
                              'nl-NL',
                              { style: 'currency', currency: 'EUR' }
                          ).format(priceValue);
                      }

                      if ( price && name ) {
                          priceLabel.innerHTML = name;
                          priceField.innerHTML = price;
                      } else {
                          priceLabel.innerHTML = '';
                          priceField.innerHTML = '';
                      }

                      calculateTotalPrice(calcTotalInputs);
                  })
                });
            });
        }

        function setupPostcodeCheck () {
            const addressFields = [
                {
                    postcode: onderhoudForm.querySelector('[name="postcode"]'),
                    huisnummer: onderhoudForm.querySelector('[name="huisnummer"]'),
                    toevoeging: onderhoudForm.querySelector('[name="huisnummer-toevoeging"]'),
                    fill: onderhoudForm.querySelector('[name="adres"]'),
                },
            ];

            addressFields.forEach(field => {
                [field.postcode, field.huisnummer, field.toevoeging]
                    .forEach(input =>
                        input.addEventListener('change', () => {
                            const postcode = field.postcode.value;
                            const huisnummer = field.huisnummer.value;
                            const toevoeging = field.toevoeging.value;

                            if ( !postcode || !huisnummer ) return;

                            const url = `${ylt.ajax_url}?action=check_postcode&postcode=${postcode}&huisnummer=${huisnummer}`;
                            fetch(url)
                                .then(r => r.json())
                                .then(response => {
                                    if ( response.title ) {
                                        field.fill.value = '';
                                    } else {
                                        field.fill.value = `${response.street} ${response.number}${toevoeging} ${response.city}`;
                                    }
                                });
                        })
                    );
            })
        }

        function setupNavigation () {
            const navButtons = document.querySelectorAll('.form-steps .step');

            navButtons.forEach(navBtn => navBtn.addEventListener('click', () => {
                const clickedStep = parseInt(navBtn.dataset.step);
                const currentStep = parseInt(navBtn.parentNode.querySelector('[aria-current]').dataset.step);

                if ( clickedStep < currentStep ) {
                    gotoPage(clickedStep);
                }
            }));
        }

        function setupValidation () {
          onderhoudForm.querySelectorAll('input')
            .forEach(input => {
              input.addEventListener('change', () => {
                validateField(input);
              });
            });
        }

        function submitForm (formData, pageIndex) {
            return fetch(`/wp-content/themes/feiken_ylt/includes/onderhoud-form/endpoints.php?action=submit&index=${pageIndex}`, {
                method: 'POST',
                body: formData,
            })
                .then(r => r.json())
                .then(() => {
                    window.location.replace(onderhoudFormHolder.dataset.redirect);
                });
        }

        function validate (formData, pageIndex) {
            return fetch(`/wp-content/themes/feiken_ylt/includes/onderhoud-form/endpoints.php?action=validate&index=${pageIndex}`, {
                method: 'POST',
                body: formData,
            })
                .then(r => r.json());
        }

        function validateField ( field ) {
          return new Promise((resolve, reject) => {
            if (field.dataset.directValidation && field.dataset.directValidation == 'true') {
              const fieldName = field.name;
              const formData = getAllFormData();

              return fetch(`/wp-content/themes/feiken_ylt/includes/onderhoud-form/endpoints.php?action=validate&index=${currentPageIndex}&field=${fieldName}`, {
                  method: 'POST',
                  body: formData,
              })
                  .then(r => r.json())
                  .then(([errors, warnings]) => {
                    if (warnings.length > 0 ) {
                      showWarnings(warnings);
                    }

                    if (errors.length > 0 ) {
                      disableNextButton();
                      showErrors(errors);
                      reject();
                    }

                    if (warnings.length === 0 && errors.length === 0) {
                      removeError(fieldName);
                    }

                    if (errors.length === 0){
                      enableNextButton();
                      resolve();
                    }
                  })
            } else {
              resolve();
            }
          });
        }

        function disableNextButton () {
          pages[currentPageIndex]
            .querySelector('.page-button.next')
            .setAttribute('disabled', 'disabled');
        }

        function enableNextButton () {
          pages[currentPageIndex]
            .querySelector('.page-button.next')
            .removeAttribute('disabled');
        }

        function showWarnings(warnings) {
          warnings.forEach(warning => {
            const fieldControl = onderhoudForm.querySelector(`.field-control:has([name="${warning.name}"])`);

            fieldControl.querySelector('.error').innerHTML = warning.message;
            fieldControl.classList.add('invalid');
            fieldControl.querySelector('.error').classList.add('warning');
          });
        }

        function showErrors (errors) {
          errors.forEach(error => {
              const fieldControl = onderhoudForm.querySelector(`.field-control:has([name="${error.name}"])`);

              fieldControl.querySelector('.error').innerHTML = error.message;
              fieldControl.classList.add('invalid');
              fieldControl.querySelector('.error').classList.remove('warning');

              if ( error.type !== '' ) {
                const fields = document.querySelectorAll(`[data-conditional-no-error="${error.name}=${error.type}"]`)
                fields.forEach(field => {
                  const fieldControl = field.closest('.field-control');
                  fieldControl.classList.remove('hidden');
                  fieldControl.querySelectorAll('input')
                    .forEach(input => input.removeAttribute('disabled'));
                });
              }
          });

          setupPageHeight();
        }

        function removeError (fieldName) {
          const fieldControl = onderhoudForm.querySelector(`.field-control:has([name="${fieldName}"])`);

          fieldControl.querySelector('.error').innerHTML = '';
          fieldControl.classList.remove('invalid');

          document.querySelectorAll(`[data-conditional-no-error^="${fieldName}="]`)
            .forEach(field => {
              field.closest('.field-control').classList.add('hidden');
              field.setAttribute('disabled', 'disabled');
            });

          setupPageHeight();
        }

        function getAllFormData () {
            const allFormData = new FormData();
            const allForms = onderhoudForm.querySelectorAll('form');
            allForms.forEach((form, formIndex) => {
                if ( formIndex <= currentPageIndex ) {
                    const current = new FormData(form);
                    for (const pair of current.entries()) {
                        allFormData.append(pair[0], pair[1]);
                    }
                }
                });

            return allFormData;
        }


        window.addEventListener('DOMContentLoaded', setupHandles);
        window.addEventListener('DOMContentLoaded', setupConditionals);
        //window.addEventListener('DOMContentLoaded', setupErrorConditionals);
        window.addEventListener('DOMContentLoaded', setupPrices);
        window.addEventListener('DOMContentLoaded', setupPostcodeCheck);
        window.addEventListener('DOMContentLoaded', setupNavigation);
        window.addEventListener('DOMContentLoaded', setupValidation);

        window.addEventListener('DOMContentLoaded', updatePage);
        window.addEventListener('load', updatePage);
        window.addEventListener('resize', updatePage);

        onderhoudForm.querySelectorAll('.onderhoud-selector input')
            .forEach(input => input.addEventListener('change', setupContractFields));

        pages
            .forEach((page, index) => {
                page.noValidate = true;

                page.addEventListener('submit', evt => {
                    evt.preventDefault();

                    const form = evt.target;
                    const fields = Array.from(form.elements);

                    fields.forEach(field => {
                        const fieldControl = field.closest('.field-control');
                        if ( !fieldControl ) return;

                        if ( field.checkValidity() ) {
                            fieldControl.classList.remove('invalid');
                        } else {
                            fieldControl.querySelector('.error').innerHTML = field.validationMessage;
                            fieldControl.classList.add('invalid');
                        }
                    });

                    const allFormData = getAllFormData();

                    if ( form.checkValidity() ) {
                        page.classList.add('loading');

                        validate(allFormData, index)
                            .then(([errors, warnings]) => {
                                page.classList.remove('loading');

                                if ( errors.length === 0 ) {
                                    if ( page === pages[pages.length-1] ) {
                                        submitForm(allFormData, index);
                                    } else {
                                        gotoNextPage();
                                    }
                                } else {
                                  console.log('submit');
                                  console.log(warnings);
                                    showErrors(errors);
                                    showWarnings(warnings);
                                    setupPageHeight();

                                    const firstError = form.querySelector('.field-control.invalid');
                                    scrollIntoView(firstError);
                                }
                            });
                    } else {
                        setupPageHeight();

                        const firstError = form.querySelector('.field-control.invalid');
                        scrollIntoView(firstError);
                    }

                })
            });

        pageButtons
            .forEach(button => button.addEventListener('click', () => {
                if ( button.classList.contains('prev') ) {
                    gotoPrevPage();
                }
            }));

        document.querySelector('.prev-btn')
            .addEventListener('click', () => {
                gotoPrevPage();
            });

        document.querySelector('.next-btn')
            .addEventListener('click', () => {
                pages[currentPageIndex].requestSubmit();
            });
    }
}
